/* Hallows Eve — theme scripts */
(function () {
  'use strict';

  var S = window.Spooky || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fx = !!S.animations && !reduceMotion;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function rand(min, max) { return min + Math.random() * (max - min); }

  /* ---------- Scroll reveal ---------- */
  var revealObserver = null;
  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
  }
  function initReveal(root) {
    $$('.reveal:not(.is-visible)', root).forEach(function (el) {
      if (revealObserver && fx) revealObserver.observe(el);
      else el.classList.add('is-visible');
    });
  }

  /* ---------- Embers (canvas) ---------- */
  function initEmbers() {
    var canvas = $('[data-embers]');
    if (!canvas || !fx || !S.embers) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w, h, particles = [], running = true;
    var colors = ['255,122,24', '255,180,60', '141,255,90'];

    function resize() {
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(initial) {
      return {
        x: rand(0, w), y: initial ? rand(0, h) : h + 10,
        r: rand(0.8, 2.6), vy: rand(0.15, 0.7), vx: rand(-0.2, 0.2),
        a: rand(0.25, 0.9), phase: rand(0, 6.28),
        c: colors[Math.random() < 0.82 ? Math.floor(rand(0, 2)) : 2]
      };
    }
    function frame(t) {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.y -= p.vy; p.x += p.vx + Math.sin(t / 900 + p.phase) * 0.25;
        var alpha = p.a * (0.6 + 0.4 * Math.sin(t / 400 + p.phase));
        ctx.beginPath();
        ctx.fillStyle = 'rgba(' + p.c + ',' + alpha.toFixed(3) + ')';
        ctx.shadowColor = 'rgba(' + p.c + ',.9)';
        ctx.shadowBlur = 8;
        ctx.arc(p.x, p.y, p.r, 0, 6.2832);
        ctx.fill();
        if (p.y < -10) particles[i] = spawn(false);
      }
      requestAnimationFrame(frame);
    }
    resize();
    var count = Math.round(Math.min(46, Math.max(16, w / 34)));
    for (var i = 0; i < count; i++) particles.push(spawn(true));
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(frame);
    });
    requestAnimationFrame(frame);
  }

  /* ---------- Bats ---------- */
  function batMarkup() {
    var tpl = document.getElementById('BatTemplate');
    return tpl ? tpl.innerHTML : '';
  }
  function initAmbientBats() {
    var layer = $('[data-ambient-bats]');
    var markup = batMarkup();
    if (!layer || !fx || !S.ambientBats || !markup) return;
    function launch() {
      if (!document.hidden) {
        var bat = document.createElement('div');
        bat.className = 'fly-bat' + (Math.random() < 0.5 ? ' fly-bat--rtl' : '');
        bat.style.setProperty('--y', rand(6, 62).toFixed(1) + '%');
        bat.style.setProperty('--size', Math.round(rand(26, 62)) + 'px');
        bat.style.setProperty('--dur', rand(8, 15).toFixed(1) + 's');
        bat.innerHTML = '<span>' + markup + '</span>';
        bat.addEventListener('animationend', function (e) { if (e.target === bat) bat.remove(); });
        layer.appendChild(bat);
      }
      setTimeout(launch, rand(4500, 11000));
    }
    setTimeout(launch, 2500);
  }
  function batBurst(el) {
    var markup = batMarkup();
    if (!fx || !markup || !el) return;
    var rect = el.getBoundingClientRect();
    var cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
    for (var i = 0; i < 9; i++) {
      var bat = document.createElement('div');
      var angle = (Math.PI * 2 * i) / 9 + rand(-0.3, 0.3);
      var dist = rand(80, 170);
      bat.className = 'burst-bat';
      bat.style.left = cx - 13 + 'px';
      bat.style.top = cy - 8 + 'px';
      bat.style.setProperty('--bx', (Math.cos(angle) * dist).toFixed(0) + 'px');
      bat.style.setProperty('--by', (Math.sin(angle) * dist - 40).toFixed(0) + 'px');
      bat.style.setProperty('--br', rand(-40, 40).toFixed(0) + 'deg');
      bat.innerHTML = markup;
      bat.addEventListener('animationend', function (e) { if (e.target === e.currentTarget) e.currentTarget.remove(); });
      document.body.appendChild(bat);
    }
  }

  /* ---------- Hero lightning ---------- */
  function initLightning(root) {
    $$('[data-hero][data-lightning]', root).forEach(function (hero) {
      if (!fx || hero.dataset.lightningReady) return;
      hero.dataset.lightningReady = '1';
      (function flash() {
        setTimeout(function () {
          if (!document.body.contains(hero)) return;
          if (!document.hidden) {
            hero.classList.add('is-flash');
            setTimeout(function () { hero.classList.remove('is-flash'); }, 750);
          }
          flash();
        }, rand(7000, 16000));
      })();
    });
  }

  /* ---------- Spider ---------- */
  function initSpider() {
    var spider = $('[data-spider]');
    if (!spider) return;
    var body = $('[data-spider-body]', spider);
    if (!body) return;
    body.addEventListener('click', function () {
      spider.classList.add('is-up');
      setTimeout(function () { spider.classList.remove('is-up'); }, 4000);
    });
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCountdown(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var target = new Date(el.dataset.date).getTime();
      var clock = $('[data-countdown-clock]', el);
      var ended = $('[data-countdown-ended]', el);
      var nodes = {
        days: $('[data-days]', el), hours: $('[data-hours]', el),
        minutes: $('[data-minutes]', el), seconds: $('[data-seconds]', el)
      };
      if (isNaN(target)) return;
      function set(node, value) {
        if (!node || node.textContent === value) return;
        node.textContent = value;
        if (fx) {
          node.classList.remove('is-tick');
          void node.offsetWidth;
          node.classList.add('is-tick');
        }
      }
      var timer;
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (clock) clock.hidden = true;
          if (ended) ended.hidden = false;
          clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        set(nodes.days, pad(Math.floor(s / 86400)));
        set(nodes.hours, pad(Math.floor((s % 86400) / 3600)));
        set(nodes.minutes, pad(Math.floor((s % 3600) / 60)));
        set(nodes.seconds, pad(s % 60));
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, isError, withCartLink) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = '';
    var text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);
    if (withCartLink && S.routes && S.routes.cart) {
      var link = document.createElement('a');
      link.href = S.routes.cart;
      link.textContent = (S.strings && S.strings.viewCart) || 'View cart';
      el.appendChild(link);
    }
    el.classList.toggle('is-error', !!isError);
    el.hidden = true;
    void el.offsetWidth;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count === 0;
      node.classList.remove('is-bumped');
      void node.offsetWidth;
      node.classList.add('is-bumped');
    });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!S.routes || !S.routes.cartAdd || !window.fetch) return;
    event.preventDefault();
    var button = $('[name="add"]', form);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }

    fetch(S.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          return data;
        });
      })
      .then(function () {
        return fetch(S.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        batBurst(button);
        toast((S.strings && S.strings.added) || 'Added', false, true);
      })
      .catch(function (err) { toast(err.message, true, false); })
      .then(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    $$('[data-product-section]', root).forEach(function (section) {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';

      function showMedia(id) {
        if (!id) return;
        var found = false;
        $$('.product__slide', section).forEach(function (slide) {
          var match = slide.dataset.mediaId === String(id);
          if (match) found = true;
        });
        if (!found) return;
        $$('.product__slide', section).forEach(function (slide) { slide.hidden = slide.dataset.mediaId !== String(id); });
        $$('[data-thumb]', section).forEach(function (thumb) { thumb.classList.toggle('is-active', thumb.dataset.thumb === String(id)); });
      }
      $$('[data-thumb]', section).forEach(function (thumb) {
        thumb.addEventListener('click', function () { showMedia(thumb.dataset.thumb); });
      });

      var qty = $('[data-qty]', section);
      if (qty) {
        var input = $('input', qty);
        $('[data-qty-minus]', qty).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        $('[data-qty-plus]', qty).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      }

      var dataNode = $('[data-variants]', section);
      var options = $('[data-options]', section);
      if (!dataNode || !options) return;
      var variants;
      try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }

      var idInput = $('[data-variant-id]', section);
      var addButton = $('[data-add]', section);
      var addLabel = $('[data-add-label]', section);
      var priceCurrent = $('[data-price-current]', section);
      var priceCompare = $('[data-price-compare]', section);
      var saleBadge = $('[data-sale-badge]', section);
      var strings = S.strings || {};

      options.addEventListener('change', function () {
        var selected = [];
        $$('input:checked', options).forEach(function (radio) {
          selected[parseInt(radio.dataset.optionPosition, 10) - 1] = radio.value;
        });
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < selected.length; j++) {
            if (variants[i].options[j] !== selected[j]) { ok = false; break; }
          }
          if (ok) { variant = variants[i]; break; }
        }
        if (!variant) {
          addButton.disabled = true;
          addLabel.textContent = strings.unavailable || 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
        if (priceCurrent) priceCurrent.innerHTML = variant.price;
        if (priceCompare) {
          priceCompare.hidden = !variant.compare;
          priceCompare.innerHTML = variant.compare || '';
        }
        if (saleBadge) saleBadge.hidden = !variant.compare;
        showMedia(variant.media);
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Collection sorting ---------- */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-sort-by]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.dataset.ready || !el.dataset.url || el.children.length) return;
      el.dataset.ready = '1';
      fetch(el.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initReveal(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Mobile menu: close on outside click ---------- */
  document.addEventListener('click', function (event) {
    $$('.nav-mobile[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  /* ---------- Boot ---------- */
  function initSections(root) {
    initReveal(root);
    initCountdown(root);
    initLightning(root);
    initProduct(root);
    initRecommendations(root);
  }
  function boot() {
    initSections(document);
    initEmbers();
    initAmbientBats();
    initSpider();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) { initSections(event.target); });
})();
